import React, { Component } from 'react';
import {Link, Redirect} from 'react-router-dom';

import { connect } from "react-redux";
import * as vignetsReducers from "../../reducers/vignets";
import * as vignetsActions from "../../actions/vignets";
import * as playlistReducers from "../../reducers/playlist";

import {withRouter} from 'react-router';

import VignetNewItem from './VignetNewItem';
import ListItem from '../common/listItem';
import ReactImageFallback from "react-image-fallback";
import { Modal, ModalBody, ModalFooter, Button} from 'reactstrap';

import Loader from 'react-loader-spinner';

class VignetContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            userDet : JSON.parse(window.localStorage.userDet),
            showPop : false,
            showShare : false,
            showStat : true
        };

        this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
        this.mToggle = this.mToggle.bind(this);
        this.showShare = this.showShare.bind(this);
        this.shareToFb = this.shareToFb.bind(this);
        this.showWebModal = this.showWebModal.bind(this);
        this.showQRModal = this.showQRModal.bind(this);
    }


    componentDidMount() {
        //this.forceUpdateHandler(10);
        this.forceUpdateHandler();

    }


    shouldComponentUpdate(nextProps, nextState){
        if(this.props !== nextProps  || this.state !== nextState) {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.vignetsData.vignetsDeleted !== prevProps.vignetsData.vignetsDeleted || this.props.vignetsData.vignetCreated !== prevProps.vignetsData.vignetCreated) {
            this.forceUpdateHandler();
        }
        if (this.props.vignetsData.searchText !== prevProps.vignetsData.searchText ) {

        }

        /*if(this.props.vignetsData.vignetsList !== prevProps.vignetsData.vignetsList) {
            for(var i=0; i< this.props.vignetsData.vignetsList.length; i++) {
                if( !this.props.vignetsData.vignetsList[i].eventTracks ) {
                    this.getVigProps(this.props.vignetsData.vignetsList[i].uniqueId , i , 'list');
                }
            }
        }*/
    }

    forceUpdateHandler(size){
        let plId = "";
        console.log(this.props);
        if( this.props.match.path === "/playlist/add/:id") {
            plId = this.props.match.params.id;
        }
        let data = { user_id : this.state.userDet.user_id , size : size?size:'', type : '',  playlistId : plId};
        this.props.allVignetsData(data);
    }

    getVigProps(vigId, itemIndex, section_name){
        let data = { vignet_id : vigId, section : 'list', index : itemIndex , section_name : section_name };
        // console.log(data)
        this.props.allVignetsProps(data);
        // console.log(this.props.vignetsData.vignetProps);
    }

    showDetailPopup(vignet) {

        console.log("showEdit");

        console.log(vignet);

        this.setState(
            {
                showPop: true,
                vignet : vignet
            },
            () => {
                console.log(this.state.showDetailPop);
                console.log(this.state.vignet);
            });

        //this.setState({playlist_name: this.props.playlistData.playListDetail? this.props.playlistData.playListDetail[0].name:''});

    }

    mToggle() {
        console.log(this.state.showPop);
        this.setState({
            showPop: !this.state.showPop
        });
    }

    toggle() {
        console.log(this.state.showCopyMsg);
        this.setState({
            showCopyMsg: !this.state.showCopyMsg
        });
    }

    showShare() {
        this.setState({
            showShare: true,
            showStat : false
        });
    }

    /*********** Copy the web url to share among users ********/
    showWebModal(vigID)
    {
        var uid= this.state.userDet.user_id;

        var e = document.createElement("textarea");
        var url ="https://a.vignets.com/react-vignet/player/?"+vigID+'/'+uid ;
        e.value = String(url);
        document.body.appendChild(e);
        e.select();
        document.execCommand("copy");
        document.body.removeChild(e);

        this.setState({
            copyUrl : url
        });

    }

    shareToFb(type, vignet_id, vignet_title) {


        var baseUrl =String('https://a.vignets.com/react-vignet/player/?'+vignet_id);

        let rootUrl = '';let shareUrl ='';


        if(type == 'fb') {
            /******************* Fb Share**************/
            let rootUrl = baseUrl + "//fb";
            shareUrl = "http://www.facebook.com/sharer/sharer.php?u="+encodeURIComponent(rootUrl);
        }
        else if(type == 'fb') {
            /******************* Whatsapp Share**************/
            rootUrl = baseUrl + "//wa";
            shareUrl = "https://api.whatsapp.com/send?text=" + rootUrl;
        }
        else if(type == 'em') {
            /******************* Email Share************/
            rootUrl = baseUrl + "//em";
            shareUrl = "mailto:?subject=" + vignet_title + "&body=" + rootUrl;
        }

        window.open(shareUrl);

    }

    /*********** Scan QR code of vignet********/
    showQRModal(vigID)
    {

        var uid= this.state.userDet.user_id;
        var url = "https://agency.vignets.com/qr-share/getqrcode.php";

        /*$.ajax({
            type: "POST",
            url: url,
            data:  JSON.stringify({
                vig_id: vigID,
                userid: uid,
                loc: String(document.location).split("?")[0]
            }),
            headers: {
                "Content-Type": "application/json"
            },
            success: function(res){
                var qrImage  = "https://agency.vignets.com/qr-share/qrcode/images/" +vigID+ ".png?" + (new Date).getTime();

                $("#qrImgCtr img").attr( 'src', qrImage);
                $("#QRvignetId").val(vigID);
                $('#QRModal').modal('show');


            }
        });*/
    }




    render() {

        const { redirect } = this.state;

        if (redirect) {
            return <Redirect to='/{builderUrl}'/>;
        }

        let vignetsList = (this.props.vignetsData.searchText || this.props.vignetsData.sort) ? this.props.vignetsData.filteredData :  this.props.vignetsData.vignetsList;
        let vignet = this.state.vignet;

       // console.log( this.props.vignetsData);
        console.log(vignetsList);
       // console.log(this.state.showDetailPop);



        return (
            <div className="list-wrap">
                <div className="list-container">

                    {!vignetsList &&
                        <div className="loaderWrapper">
                            <Loader type="ThreeDots" color="#23ada6"  height="50" width="50"/>
                        </div>
                    }
                    <VignetNewItem forceUpdateHandler={this.forceUpdateHandler.bind(this)}/>

                    {vignetsList &&
                    vignetsList.map((entry, index) => <ListItem detail={entry} id={index}  showDetailPopup={this.showDetailPopup.bind(this)} itemType="vignets" />)

                    }


                </div>



            </div>

        );
    }
}


function mapStateToProps(state) {
    return {
        vignetsData  :vignetsReducers.getVignetsData(state),
        playlistData  :playlistReducers.getPlaylistData(state)
    };

}
export default  withRouter(connect(mapStateToProps, {
    allVignetsData : vignetsActions.fetchVignetsData,
    allFilteredData : vignetsActions.searchVignets,
    allVignetsProps : vignetsActions.getVignetProps
})(VignetContainer));



// WEBPACK FOOTER //
// ./src/components/vignets/VignetContainer.js